import React from "react";
import {Field, Form, Formik} from "formik";
import {Input} from "../../../../_metronic/_partials/controls";
import {useHistory} from "react-router-dom";

export function OrderEditForm({
                                  order
                              }) {

    const history = useHistory();


    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={order}
            >
                {({handleSubmit}) => (

                    <Form className="form form-label-right">

                        <div className="card card-custom gutter-b card-border card-fit">
                            <div className="card-header">
                                <div className="card-title">
                                    <h3 className="card-label">
                                        مشخصات سفارش
                                    </h3>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-lg-4">
                                        <Field
                                            name="id"
                                            component={Input}
                                            placeholder="شماره سفارش"
                                            label="شماره سفارش"
                                        />

                                    </div>
                                    <div className="col-lg-4">
                                        <Field
                                            name="bascket_id"
                                            component={Input}
                                            placeholder="شماره سبد"
                                            label="شماره سبد"
                                        />
                                    </div>
                                    <div className="col-lg-4">
                                        <Field
                                            name="price"
                                            component={Input}
                                            placeholder="قیمت"
                                            label="قیمت"
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-lg-4">
                                        <Field
                                            name="status.name"
                                            component={Input}
                                            placeholder="وضعیت"
                                            label="وضعیت"
                                        />
                                    </div>
                                    <div className="col-lg-4">
                                        <a className="btn btn-primary d-block"
                                           target="_blank"
                                           href={`/customer/products/${order.product_id}`}>
                                            نمایش محصول
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </Form>
                )}
            </Formik>
        </>
    );
}
